import type { Locale } from './validation.ts';
import type { DateKey } from './time.ts';

const LANG: Record<Locale, string> = { de: 'de-DE', en: 'en-GB' };

export function formatPrice(value: number, locale: Locale, currency = 'EUR'): string {
  return new Intl.NumberFormat(LANG[locale], { style: 'currency', currency }).format(value);
}

export function formatTime(date: Date, locale: Locale, tz: string): string {
  return new Intl.DateTimeFormat(LANG[locale], { timeZone: tz, hour: '2-digit', minute: '2-digit' }).format(date);
}

export function formatDateTime(date: Date, locale: Locale, tz: string): string {
  return new Intl.DateTimeFormat(LANG[locale], {
    timeZone: tz,
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

/** Formats a calendar date key; noon UTC keeps it on the same day in every zone. */
export function formatDateKey(date: DateKey, locale: Locale, opts: Intl.DateTimeFormatOptions): string {
  return new Intl.DateTimeFormat(LANG[locale], { ...opts, timeZone: 'UTC' }).format(new Date(`${date}T12:00:00Z`));
}

export function formatDuration(min: number, locale: Locale): string {
  return new Intl.NumberFormat(LANG[locale], { style: 'unit', unit: 'minute', unitDisplay: 'short' }).format(min);
}

/** Pick `name_de` / `name_en` / ... with fallback to `name`. */
export function localized<T extends object>(obj: T, field: string, locale: Locale): string {
  const o = obj as Record<string, unknown>;
  const v = o[`${field}_${locale}`] ?? o[field];
  return typeof v === 'string' ? v : '';
}
